<template>
  <div class="xes-1v1-select-grade">
    <ul v-if="gradeList.length">
      <li v-for="(item, index) in gradeList" :key="index" class="xes-1v1-select-grade-group">
        <p>{{ item.group }}</p>

        <div style="display: flex; justify-content: space-between; flex-wrap: wrap;">

          <div class="xes-1v1-select-grade-content" v-for="(gradeItem, sub_index) in item.list" :key="sub_index"
               :class="{ active: select_index === index && select_sub_index === sub_index }"
               @click="select_curr_grade(index, sub_index)">
            {{ gradeItem.gradeName }}
          </div>
        </div>
      </li>
    </ul>
    <div class="xes-1v1-select-grade-next">
      <button class="xes-1v1-select-grade-next-btn"
              :class="{'xes-1v1-select-city-next-btn-active' :  this.select_grade_name}"
              @click="submit_all">下一步
      </button>
    </div>
  </div>
</template>

<script>


import {Toast} from "vant";

export default {
  data() {
    return {
      gradeList: [
        {
          "group": "高中",
          list: [
            {
              "gradeName": "高一",
              "gradeId": "4",
            },
            {
              "gradeName": "高二",
              "gradeId": "5",
            },
            {
              "gradeName": "高三",
              "gradeId": "6",
            }
          ]
        }
      ],
      select_index: -1,
      select_sub_index: -1,
      select_grade_name: ''
    };
  },

  methods: {
    select_curr_grade(index, sub_index) {
      this.select_index = index;
      this.select_sub_index = sub_index;
      this.select_grade_name = this.gradeList[this.select_index].list[this.select_sub_index].gradeName
    },
    submit_all() {
      if (!this.select_grade_name) {
        return
      }
      let tempGrade = this.gradeList[this.select_index].list[this.select_sub_index].gradeId
      localStorage.setItem("talGradeId", tempGrade)
      let tempCity = localStorage.getItem("talCityCode")
      let tempUid = localStorage.getItem("talUid")

      let params = {
        action: 2, // 1 拒绝
        channel: "app",
        grade_id: parseInt(tempGrade), // 10 11 12
        city_code: tempCity.toString(),
        uid: parseInt(tempUid)
      }
      this.$api.clueTeacherForm.authSubmit(params).then((res) => {
        if (JSON.stringify(res) !== "{}") {
          if (res.error_code === 0 && res.result) {
            this.$router.push({
              path: "/auth/authResult",
              query: {
                // succFlag: res.result.status,
                succFlag: 0,
                tips: res.result.message,
              }
            });
          } else {
            Toast(res.message)
          }
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.xes-1v1-select-grade {
  margin: 48px 32px 0 32px;

  h2 {
    font-size: 18px;

    font-weight: bold;
    color: #333333;
  }

  &-tips {
    margin-top: 30px;
    font-weight: bold;
    font-size: 20px;
    border-bottom: #8e949e 1px;
  }

  .xes-1v1-select-grade-next {

    margin-top: 30px;
    display: flex;
    justify-content: center;
    position: fixed;
    bottom: 50px;
    left: 20px;
    right: 20px;

    &-btn {
      font-size: 16px;
      border-radius: 20px;
      color: white;
      height: 44px;
      width: 100%;
      background-color: #E7E8EA;
    }

    .xes-1v1-select-city-next-btn-active {

      background-color: red;
      color: white;
    }
  }

  &-group {
    margin-top: 50px;

    p {
      font-weight: bold;
      font-size: 20px;
      margin: 16px 0 16px 0;

    }

    .xes-1v1-select-grade-content {
      background: #F7F8FA;
      text-align: center;
      height: 32px;
      font-size: 14px;
      margin: 0 auto;
      border-style: solid;
      border-radius: 4px;
      width: 30%;
      line-height: 28px;
    }

    .xes-1v1-select-grade-content.active {
      background: #FFF0EB;
      color: red;
    }
  }

}
</style>